import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Col, Row, Divider, Button, Table } from '_zari/core'

import * as SocioService from 'services/socio.service'

import { IdGen } from 'utils'

import * as FormGroups from './formGroups'
import * as Sections from './sections'

const CrudContactosModal = ({ show, handleClose, idSocio }) => {
  const __zariContext = React.useContext(ZariContext)

  const [sectionKey, setSectionKey] = React.useState(IdGen.newId())
  const [numeroDocumento, setNumeroDocumento] = React.useState('')
  const [razonSocial, setRazonSocial] = React.useState('')
  const [contactos, setContactos] = React.useState([])

  const edicionDataRef = React.useRef({})

  const actualizarContactos = React.useCallback(() => {
    SocioService.obtenerContactosxIdSocio(idSocio)
      .then(({ data }) => {
        if (data) {
          setNumeroDocumento(data.numeroDocumento)
          setRazonSocial(data.razonSocial)
          setContactos(data.contactos || [])
        }
      })
      .catch(() => {
        setContactos([])
      })
  }, [idSocio])

  React.useEffect(() => {
    actualizarContactos()
  }, [actualizarContactos])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      SocioService.obtenerContactoxIdSocioxIdContacto(idSocio, _id)
        .then(({ data }) => {
          edicionDataRef.current = data
          setSectionKey(IdGen.newId())
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [idSocio, __zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      SocioService.eliminarContactoxIdSocioxIdContacto(idSocio, _id)
        .then(() => {
          setSectionKey(IdGen.newId())
          actualizarContactos()
        })
        .catch(({ data: { error } }) => __zariContext.toast('error', error))
    },
    [idSocio, __zariContext, actualizarContactos]
  )

  const refrescarSection = React.useCallback(() => {
    edicionDataRef.current = {}
    setSectionKey(IdGen.newId())
  }, [])

  return (
    <Modal show={show} size='xl'>
      <Modal.Header>
        <Modal.Title>Control Contactos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <FormGroups.NumeroDocumentoFormGroup value={numeroDocumento} />
            <FormGroups.RazonSocialFormGroup value={razonSocial} />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col md={6}>
            <Table
              filas={contactos}
              maxRowsShown={10}
              headRows={[
                {
                  label: 'Nombre'
                },
                {
                  label: 'Email'
                },
                {
                  label: ''
                }
              ]}
              rowTemplate={row => (
                <Table.Row key={row._id}>
                  <Table.Cell>{row.nombre || '--'}</Table.Cell>
                  <Table.Cell>{row.email1 || '--'}</Table.Cell>
                  <Table.Cell>
                    <Table.Dropdown>
                      {({ handleClose }) => [
                        <Table.Dropdown.Item
                          key='editar-contacto'
                          handleClose={handleClose}
                          onClick={e => clickEditar({ _id: row._id })}
                        >
                          Editar
                        </Table.Dropdown.Item>,
                        <Table.Dropdown.Item
                          key='eliminar-contacto'
                          handleClose={handleClose}
                          onClick={e => clickEliminar({ _id: row._id })}
                        >
                          Eliminar
                        </Table.Dropdown.Item>
                      ]}
                    </Table.Dropdown>
                  </Table.Cell>
                </Table.Row>
              )}
            />
          </Col>
          <Col md={6}>
            <Sections.CrearEditarContactoSection
              key={sectionKey}
              editarData={edicionDataRef.current}
              idSocio={idSocio}
              refrescarSection={refrescarSection}
              refrescarTabla={actualizarContactos}
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' outline onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(CrudContactosModal)
